export default __webpack_public_path__ + "static/media/investPic.195c13ec.svg";